import { Box } from "@material-ui/core";
import React from "react";

import ScrollBanner from "./ScrollBanner";

interface Props {
  handleOpenModal: () => void;
  onClickTaxReturnBanner: () => void;
  onClickMsinsBanner: () => void;
  onClickCampaignAccept: () => void;
  onClickSecondOpinion: () => void;
  onClickSmaulBanner: () => void;
  onClickWebinarBanner: () => void;
  onClickCozuchiBanner: () => void;
}

export const AnnouncementSection: React.FC<Props> = ({
  handleOpenModal,
  onClickTaxReturnBanner,
  onClickMsinsBanner,
  onClickCampaignAccept,
  onClickSecondOpinion,
  onClickSmaulBanner,
  onClickWebinarBanner,
  onClickCozuchiBanner,
}) => {
  return (
    <Box>
      <ScrollBanner
        handleOpenModal={handleOpenModal}
        onClickTaxReturnBanner={onClickTaxReturnBanner}
        onClickMsinsBanner={onClickMsinsBanner}
        onClickCampaignAccept={onClickCampaignAccept}
        onClickSecondOpinion={onClickSecondOpinion}
        onClickSmaulBanner={onClickSmaulBanner}
        onClickWebinarBanner={onClickWebinarBanner}
        onClickCozuchiBanner={onClickCozuchiBanner}
      />
    </Box>
  );
};

export default AnnouncementSection;
